import { render, staticRenderFns } from "./Part.vue?vue&type=template&id=246283a8"
import script from "./Part.vue?vue&type=script&lang=js"
export * from "./Part.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports